import { render } from "./DigitalWorks.vue?vue&type=template&id=1c547a29&scoped=true"
import script from "./DigitalWorks.vue?vue&type=script&lang=js"
export * from "./DigitalWorks.vue?vue&type=script&lang=js"

import "./DigitalWorks.vue?vue&type=style&index=0&id=1c547a29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c547a29"]])

export default __exports__